import { NgClass } from '@angular/common';
import { Component, ViewEncapsulation, input } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import type { TextPreset, TextPresetCompounds } from '../email-text/email-text.component';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  selector: 'email-link',
  styleUrls: ['./email-link.component.less'],
  template: `<a
    [href]="prefix() + href().toJSON()"
    [target]="target()"
    [ngClass]="'link-' + (textOpts()?.color || 'primary')"
  >
    <email-text
      [contents]="label()"
      [size]="textOpts()?.size"
      [behavior]="textOpts()?.behavior"
      [vAlign]="textOpts()?.vAlign"
      [bold]="textOpts()?.bold"
      [color]="textOpts()?.color"
      [presetName]="textPreset()"
    />
  </a>`,
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, EmailTextComponent],
})
export class EmailLinkComponent {
  public readonly href = input<WrappedValue<string>>(undefined!);
  public readonly label = input<WrappedValue<string>>(undefined!);
  public readonly prefix = input<string>('');
  public readonly target = input<string | undefined>('_blank');
  public readonly textOpts = input<TextPresetCompounds>();
  public readonly textPreset = input<TextPreset>();
}
